import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFold = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#pet__clip0_121_17507)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#AAAAAA",
			d: "M12 8L6 14L7.41 15.41L12 10.83L16.59 15.41L18 14L12 8Z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "pet__clip0_121_17507",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgFold);
export default ForwardRef;
